import { TeamInstructionActionSet, TeamInstructionKindForPermissionGrants } from './constants';

export const getRemoveMaintainerSemanticPatchInstructions = (maintainerID: string) => [
  {
    actionSet: TeamInstructionActionSet.MAINTAIN_TEAM,
    actions: [],
    kind: TeamInstructionKindForPermissionGrants.REMOVE_PERMISSION_GRANTS,
    memberIDs: [maintainerID],
  },
];
